export default __webpack_public_path__ + "static/media/1.ca6a8d81.jpg";